var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.383,
    height: 16,
    viewBox: "0 0 17.383 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3318.523 -7.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ofis_za_vzimane_stroke",
    "data-name": "Ofis za vzimane stroke",
    transform: "translate(3319.209 7.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13037",
    "data-name": "Group 13037",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13037",
    "data-name": "Rectangle 13037",
    width: 16,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13037_-_Outline",
    "data-name": "Rectangle 13037 - Outline",
    d: "M1,1V15H15V1H1M0,0H16V16H0Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.251 1.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M2.772,0,0,4.141H15.5L12.67,0Z",
    transform: "translate(0 0)",
    fill: "#212121",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M13.446,8.294H0L.008,7.257H1.037V0H12.488V7.257h.989l-.031,1.036ZM5.184,2.073V7.257h3.11V2.073Z",
    transform: "translate(0.998 5.183)",
    fill: "#212121",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeFilter);
export default __webpack_public_path__ + "static/media/office_filter.82f7f9e52f2a706a541d07d7c7cc05a9.svg";
export { ForwardRef as ReactComponent };